import React from 'react'
import { useCallback, useEffect, useState,useRef } from 'react'
import { useDrop } from 'react-dnd'
import { Box } from './Box'
import { buildBox } from './ConfigItem'
import update from 'immutability-helper'
import MonitorChart from '../VitalSign/MonitorChart'
import ReportResourceContent from './ReportResourceContent'

const style = {}
const DEFAULT_BOX = {
  top: 0,
  left: 0,
  title: '',
  itemType: 'text',
  fieldName: '',
  defaultValue: '',
  value: '',
}
const EMPTY_REPORT_PARAMS = {}

export const PrintArea = (props) => {
  const {
    boxes,
    layout,
    publish,
    activeItem,
    setRef,
    disabled,
    pageNo,
    totalPage,
    pageNoOfLayoutPage = 1,
    totalPageOfLayoutPage = 1,
    dataSourceList = [],
    reportParams = EMPTY_REPORT_PARAMS,
    className = '',
    backgroundContent = null,
  } = props
  //const [activeId,setActiveId] = useState('')
  const [lastPos, setLastPos] = useState({ top: 0, left: 0, width: 0 })
  const [selectionBox, setSelectionBox] = useState(null)
  const [resourceSizes, setResourceSizes] = useState({})
  const printAreaRef = useRef(null)
  const selectionBoxRef = useRef(null)
  const suppressNextClickRef = useRef(false)
  const [drop2] = useDrop(() => ({
    accept: 'box',
    drop: () => ({ name: 'PrintArea' }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }))

  const hideSourceOnDrag = true

  const getPositionValue = (value) => {
    const parsed = parseFloat(value)
    return Number.isFinite(parsed) ? parsed : 0
  }

  const getRelativePoint = (event) => {
    const node = printAreaRef.current
    if (!node) return { x: 0, y: 0 }

    const rect = node.getBoundingClientRect()

    return {
      x: Math.max(0, Math.min(event.clientX - rect.left, rect.width)),
      y: Math.max(0, Math.min(event.clientY - rect.top, rect.height)),
    }
  }

  const getNormalizedSelectionBox = (box) => {
    if (!box) return null

    return {
      left: Math.min(box.startX, box.endX),
      top: Math.min(box.startY, box.endY),
      width: Math.abs(box.endX - box.startX),
      height: Math.abs(box.endY - box.startY),
    }
  }

  const intersects = (a, b) =>
    a.left < b.left + b.width &&
    a.left + a.width > b.left &&
    a.top < b.top + b.height &&
    a.top + a.height > b.top

  const selectBoxesInArea = (box) => {
    const node = printAreaRef.current
    const selection = getNormalizedSelectionBox(box)
    if (!node || !selection) return

    if (selection.width < 4 && selection.height < 4) return

    const nodeRect = node.getBoundingClientRect()
    const selectedIds = Array.from(node.querySelectorAll('[data-box-id]'))
      .filter((boxNode) => {
        if (boxNode.dataset.boxLocked === 'true') return false

        const boxRect = boxNode.getBoundingClientRect()
        return intersects(selection, {
          left: boxRect.left - nodeRect.left,
          top: boxRect.top - nodeRect.top,
          width: boxRect.width,
          height: boxRect.height,
        })
      })
      .map((boxNode) => boxNode.dataset.boxId)

    props.onAreaSelect(selectedIds)
    suppressNextClickRef.current = true
  }

  const onSelectionMouseDown = (event) => {
    if (
      disabled ||
      event.button !== 0 ||
      event.target?.closest?.('.box') ||
      event.target?.closest?.(
        'input, textarea, select, button, [contenteditable="true"]',
      )
    ) {
      return
    }

    const point = getRelativePoint(event)
    const nextSelectionBox = {
      startX: point.x,
      startY: point.y,
      endX: point.x,
      endY: point.y,
    }

    selectionBoxRef.current = nextSelectionBox
    setSelectionBox(nextSelectionBox)
    event.preventDefault()
  }

  useEffect(() => {
    if (!selectionBox) return undefined

    const onMouseMove = (event) => {
      const point = getRelativePoint(event)
      const nextSelectionBox = {
        ...selectionBoxRef.current,
        endX: point.x,
        endY: point.y,
      }

      selectionBoxRef.current = nextSelectionBox
      setSelectionBox(nextSelectionBox)
    }

    const onMouseUp = () => {
      selectBoxesInArea(selectionBoxRef.current)
      selectionBoxRef.current = null
      setSelectionBox(null)
      window.setTimeout(() => {
        suppressNextClickRef.current = false
      }, 0)
    }

    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)

    return () => {
      window.removeEventListener('mousemove', onMouseMove)
      window.removeEventListener('mouseup', onMouseUp)
    }
  }, [selectionBox])

  const onSelectionClick = (event) => {
    if (!suppressNextClickRef.current) return

    suppressNextClickRef.current = false
    event.stopPropagation()
  }

  const moveBox = (item, left, top) => {
    let { id } = item
    //console.log('drop', item, props)
    if (id) {
      // props.setBoxes(update(boxes, {
      //     [id]: {
      //         $merge: { left, top },
      //     },
      // }));
      let last = {
        ...item,
        id,
        left,
        top,
        moveDelta: {
          left: left - getPositionValue(item.left),
          top: top - getPositionValue(item.top),
        },
      }
      setLastPos({ left, top })
     // console.log('a.id', left,top)
      props.onItemChange(last)
    } else {
      if (item.type === 'pdf' || item.fullPage) {
        left = 0
        top = 0
        item.width = item.width || '100%'
        item.height = item.height || '100%'
        item.fullPage = true
      }

      let box = Object.assign(
        item,
        { top: top, left: left, value: item.name, page: props.page },
        buildBox(item)
      )
      //console.log('a', box, lastPos,left,top)
      //props.setBoxes(Object.assign(boxes,box))
      props.onItemAdd(box)
    }
  }
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: 'box',
      canDrop: () => !disabled,
      drop(item, monitor) {
        if (disabled) return undefined
        const dropPosition = monitor.getClientOffset();
        const delta = monitor.getDifferenceFromInitialOffset()
        const dropTarget = document.getElementById('dropTarget-'+pageNo);

        // Get the position of the drop target relative to the document
        const targetPosition = dropTarget.getBoundingClientRect();
        //console.log('drop',item,monitor,dropPosition,delta,targetPosition)        
        let left = Math.round(getPositionValue(item.left) + delta.x)
        let top = Math.round(getPositionValue(item.top) + delta.y)
        if(!item.id){
          left = dropPosition.x - targetPosition.left
          top = dropPosition.y - targetPosition.top
        }
        moveBox(item, left, top)
        
        return undefined
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [moveBox, disabled]
  )

  const setPrintAreaNode = useCallback(
    (node) => {
      printAreaRef.current = node
      if (!disabled) drop(node)
    },
    [disabled, drop],
  )

  const isActive = canDrop && isOver
  let backgroundColor = 'white'
  if (isActive) {
    backgroundColor = 'lightgray'
  } else if (canDrop) {
    backgroundColor = 'lightgray'
  }
  const onBoxClick = (item, event) => {
    //console.log('onClick',item)
    //setActiveId(item.id)
    props.onItemClick(item, event)
  }

  const onBoxDoubleClick = (item) => {
    //console.log('onClick',item)
    //setActiveId(item.id)
    if(props.onItemDoubleClick)
      props.onItemDoubleClick(item)
  }


  const onBoxChange = (item) => {
    //console.log('onChange',item)
    //setActiveId(item.id)
    props.onItemChange(item)
  }

  const onClick = () => {
    console.log('onclick')
    //setActiveId('')
  }

  const ddItems = () => {
    const boxKeys = Object.keys(boxes).sort((a, b) => {
      const aBackground = boxes[a]?.isBackground === true ? 0 : 1
      const bBackground = boxes[b]?.isBackground === true ? 0 : 1

      return aBackground - bBackground
    })

    return boxKeys.map((key) => {
      const { left, top, width, height, title, value } = boxes[key]
      const resourceSize = resourceSizes[key]

      const resourceContent =
        boxes[key]?.type === 'report_resource' ? (
          <ReportResourceContent
            item={boxes[key]}
            reportParams={reportParams}
            pageNo={pageNo}
            totalPage={totalPage}
            pageNoOfLayoutPage={pageNoOfLayoutPage}
            totalPageOfLayoutPage={totalPageOfLayoutPage}
            onLayoutResolved={(nextSize) => {
              setResourceSizes((currentSizes) => {
                if (
                  currentSizes[key]?.width === nextSize.width &&
                  currentSizes[key]?.height === nextSize.height
                ) {
                  return currentSizes
                }

                return {
                  ...currentSizes,
                  [key]: nextSize,
                }
              })
            }}
          />
        ) : null

      return (
        <Box
          key={key}
          id={key}
          disabled={disabled}
          left={left}
          top={top}
          width={resourceSize?.width || width}
          height={resourceSize?.height || height}
          activeBackground={activeItem && activeItem.id && key == activeItem.id}
          multiSelected={props.selectedItemIds?.includes(String(key))}
          hideSourceOnDrag={hideSourceOnDrag}
          item={boxes[key]}
          onClick={(item, event) => onBoxClick(item, event)}
          onDoubleClick={(item) => onBoxDoubleClick(item)}
          onChange={(item) => onBoxChange(item)}
          pageNo={pageNo}
          pageNoOfLayoutPage={pageNoOfLayoutPage}
          totalPage={totalPage}
          totalPageOfLayoutPage={totalPageOfLayoutPage}
          draggable={true}
          layouts={layout}
          pdfOverlayMode={props.pdfOverlayMode === true}
          showBorder={publish?.showBorder}
          dataSourceList={dataSourceList}
        >
          {resourceContent}
        </Box>
      )
    })
  }

  let printStyle = Object.assign(
    { backgroundColor },
    { width: '21cm', height: '29.7cm' },
    props.layout
  )

  const fontFamily = {angsana:'font-angsana',THSarabunNew:'font-sarabun-new',Prompt:'font-prompt',sarabun:'font-sarabun'}
  const normalizedSelectionBox = getNormalizedSelectionBox(selectionBox)

  return (
    <div
      ref={setPrintAreaNode}
      id={'dropTarget-'+pageNo}
      className={`print-area ${className} ${
        fontFamily[layout.fontFamily]?fontFamily[layout.fontFamily]:'font-sarabun'        
      }  page-${layout.orientation} ${layout.fontSize?layout.fontSize:''}
      `}
      role={'PrintArea'}
      style={printStyle}
      onMouseDown={onSelectionMouseDown}
      onClick={onSelectionClick}
    >
      {backgroundContent}
      <div className="print-border-margin">
        {isActive ? 'Release to drop' : ''}
        {ddItems()}
        {normalizedSelectionBox && (
          <div
            style={{
              position: 'absolute',
              left: normalizedSelectionBox.left,
              top: normalizedSelectionBox.top,
              width: normalizedSelectionBox.width,
              height: normalizedSelectionBox.height,
              border: '1px dashed gray',
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
              pointerEvents: 'none',
              zIndex: 9999,
            }}
          />
        )}
        {/* <MonitorChart /> */}
      </div>
    </div>
  )
}

PrintArea.defaultProps = {
  onItemChange: () => {},
  onItemAdd: () => {},
  onAreaSelect: () => {},
  disabled: false,
  pageNo: 1,
  totalPage: 1,
}
